<template>
    <div>
        <div v-if="areStudentsRegistered">
            <div class="my-3" style="min-height: 30px;">
                <b-button
                    v-if="isUserStudenTeacherOrBetter"
                    variant="primary"
                    v-b-tooltip.hover
                    title="Agregar estudiantes seleccionados como participantes"
                    :disabled="!isAnyStudentSelected"
                    @click="onAddSelectedStudents()"
                >
                    <b-icon-person-plus-fill /> Agregar
                </b-button>
                <b-button
                    v-if="isUserStudenTeacherOrBetter && !canEditSurvey"
                    class="ml-2"
                    variant="danger"
                    v-b-tooltip.hover
                    title="Remover estudiantes seleccionados de participantes"
                    :disabled="!isAnyStudentSelected"
                    @click="onRemoveSelectedStudents()"
                >
                    <b-icon-person-dash-fill /> Remover
                </b-button>
            </div>

            <div class="my-3">
                <h5>Selección Rápida:
                    <b-form-checkbox
                        v-for="section in sectionNames"
                        :key="`section-${section}`"
                        :name="`quick-sel-${section}`"
                        @change="quickSectionSelection($event, section)"
                        button button-variant="outline-primary"
                        class="ml-2"
                    >
                        <div class="px-2">{{ section }}</div>
                    </b-form-checkbox>
                </h5>
            </div>

            <b-row class="mb-3">
                <b-col sm="6">
                    <strong>Estudiantes Participando: </strong>{{ selectedSurveyObject.studentSurveyCount }}
                </b-col>
                <b-col sm="6">
                    <span v-if="selectedStudentsNumber">
                        <strong>Estudiantes Seleccionados: </strong>{{ selectedStudentsNumber }}
                    </span>
                </b-col>
            </b-row>

            <b-tabs active-nav-item-class="bg-primary text-white">
                <b-tab
                    v-for="(studentRows, courseSection) in studentSections"
                    :key="`section-${courseSection}`"
                    :title="courseSection"
                >
                    <b-table
                        :ref="`participantsTable_${courseSection}`"
                        v-if="studentRows.length"
                        selectable
                        select-mode="multi"
                        responsive
                        :items="studentRows"
                        :fields="studentSurveyFields"
                        :sort-by="'lastname'"
                        :sort-desc="false"
                        @row-selected="onRowSelected($event, courseSection)"
                    >
                        <template v-slot:cell(selected)="{ rowSelected }">
                            <template v-if="rowSelected">
                                <b-icon-check-square/>
                                <span class="sr-only">Selected</span>
                            </template>
                            <template v-else>
                                <b-icon-square/>
                                <span class="sr-only">Not selected</span>
                            </template>
                        </template>
                        <template
                            v-if="isUserStudenTeacherOrBetter"
                            v-slot:cell(actions)="data"
                        >
                            <span>
                                <b-button
                                    v-if="isUserStudenTeacherOrBetter && data.item.studentSurvey === null"
                                    size="sm"
                                    variant="primary"
                                    @click="onAddSelectedStudents(data.item.studentSiteId)"
                                >
                                    <b-icon-person-plus-fill />
                                </b-button>
                                <b-button
                                    v-if="isUserStudenTeacherOrBetter && data.item.studentSurvey"
                                    class="ml-2"
                                    size="sm"
                                    variant="danger"
                                    @click="onRemoveSelectedStudents(data.item.studentSiteId)"
                                >
                                    <b-icon-person-dash-fill />
                                </b-button>
                            </span>
                        </template>
                    </b-table>
                    <h5 v-else class="text-center pt-5">
                        No existe ningún estudiante registrado en esta sección.
                    </h5>
                </b-tab>
            </b-tabs>
        </div>
        <h4 v-else class="mt-3">
            No existen estudiantes registrados en este sitio.
        </h4>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
    name: 'SurveyParticipants',
    data () {
        return {
            selectedBySection: {},
            isAnyStudentSelected: false,
            selectedStudentsNumber: 0
        }
    },
    computed: {
        ...mapState([
            'activeSite',
            'selectedSurveyObject'
        ]),
        ...mapGetters([
            'isUserStudenTeacherOrBetter',
            'getSurveyStudentSections',
            'canEditSurvey'
        ]),
        studentSections () {
            let formattedSections = {}
            let sections = this.selectedSurveyObject.sections
            if (this.selectedSurveyObject && this.areStudentsRegistered) {
                for (let sectionName in sections) {
                    formattedSections[sectionName] = sections[sectionName].map((student) => {
                        let rowVariant = student.studentSurvey ? 'info' : 'light'
                        return {
                            ...student,
                            _rowVariant: rowVariant
                        }
                    })
                }
                return formattedSections
            }
            return {}
        },
        sectionNames () {
            if (this.selectedSurveyObject) {
                return Object.keys(this.selectedSurveyObject.sections)
            }
            return []
        },
        areStudentsRegistered () {
            var sections = this.selectedSurveyObject.sections
            for (var section in sections) {
                if (hasOwnProperty.call(sections, section)) return true
            }
            return false
        },
        studentSurveyFields () {
            let fields = [
                { key: 'selected', label: '', class: 'text-center' },
                { key: 'identityCard', label: '# Cédula' },
                { key: 'lastname', label: 'Apellido', sortable: true },
                { key: 'name', label: 'Nombre' }
            ]
            if (this.isUserStudenTeacherOrBetter) {
                fields.push({ key: 'actions', label: 'Acciones', class: 'text-center' })
            }
            return fields
        }
    },
    methods: {
        ...mapActions([
            'readSingleSiteTeacherSurvey',
            'addStudentsToSurvey',
            'removeStudentsFromSurvey'
        ]),
        onRowSelected (items, sectionName) {
            this.selectedBySection[sectionName] = items.map((item) => item.studentSiteId)
            this.isAnyStudentSelected = this.checkIfStudentSelected()
            this.selectedStudentsNumber = this.getAllSelectedStudentSiteIds().length
        },
        selectAllRowsInSection (sectionName) {
            this.$refs.selectableTable.selectAllRows()
        },
        quickSectionSelection (checked, sectionName) {
            var refName = `participantsTable_${sectionName}`
            if (this.$refs[refName].length) {
                if (checked) {
                    this.$refs[refName][0].selectAllRows()
                } else {
                    this.$refs[refName][0].clearSelected()
                }
            }
        },
        getAllSelectedStudentSiteIds () {
            let studentSiteIds = []
            for (var section in this.selectedBySection) {
                if (this.selectedBySection[section].length) {
                    studentSiteIds = studentSiteIds.concat(this.selectedBySection[section])
                }
            }
            return studentSiteIds
        },
        checkIfStudentSelected () {
            for (var section in this.selectedBySection) {
                if (this.selectedBySection[section].length) {
                    return true
                }
            }
            return false
        },
        async onAddSelectedStudents (studentSiteId = null) {
            let singleStudentText = '¿Esta seguro que desea agregar a este estudiante ' +
                'como participante de esta encuesta/quiz?'
            let multipleStudentsText = '¿Esta seguro que desea agregar todos los estudiantes ' +
                'seleccionados como participantes de esta encuesta/quiz?'
            let modalBodyText = this.$createElement('p', [
                studentSiteId !== null ? singleStudentText : multipleStudentsText,
                this.$createElement('br'),
                this.$createElement('br'),
                'La encuesta no será editable mientras existan participantes. Para volver a ' +
                'editar la encuesta/quiz deberá remover a todos los participantes.'
            ])
            try {
                let value = await this.$bvModal.msgBoxConfirm([modalBodyText], {
                    title: '¡Atención!',
                    okVariant: 'primary',
                    okTitle: 'Agregar',
                    cancelTitle: 'Cancelar',
                    centered: true
                })
                if (value) {
                    // Add the students to participants after confirmation
                    var loader = this.$loading.show()
                    try {
                        const payloadData = {
                            courseSiteId: this.activeSite.id,
                            surveyId: this.selectedSurveyObject.id,
                            studentSiteIds: studentSiteId !== null ? [studentSiteId] : this.getAllSelectedStudentSiteIds()
                        }
                        let addedParticipants = await this.addStudentsToSurvey(payloadData)
                        const reloadPayload = { courseSiteId: this.activeSite.id, surveyId: this.selectedSurveyObject.id }
                        await this.readSingleSiteTeacherSurvey(reloadPayload)
                        if (addedParticipants > 0) {
                            this.$root.infoToast(`Se han agregado ${addedParticipants} participante(s) a esta encuesta/quiz.`)
                        } else {
                            this.$root.warningToast(`Los estudiantes seleccionados ya son participantes de la encuesta.`, 'Atención')
                        }
                    } catch (error) {
                        console.log({ error: error })
                        this.$root.dangerToast('No se pudo agregar participantes a la encuesta/quiz, intente más tarde.')
                    } finally {
                        loader.hide()
                    }
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        },
        async onRemoveSelectedStudents (studentSiteId = null) {
            let singleStudentText = '¿Esta seguro que desea remover a este estudiante ' +
                'como participante de esta encuesta/quiz?'
            let multipleStudentsText = '¿Esta seguro que desea remover todos los estudiantes ' +
                'seleccionados como participantes de esta encuesta/quiz?'
            let modalBodyText = this.$createElement('p', [
                studentSiteId !== null ? singleStudentText : multipleStudentsText,
                this.$createElement('br'),
                this.$createElement('br'),
                'Al remover a un estudiante también se borrará cualquier respuesta registrada ' +
                'de dicho estudiante asociada a esta encuesta/quiz.'
            ])
            try {
                let value = await this.$bvModal.msgBoxConfirm([modalBodyText], {
                    title: '¡Atención!',
                    okVariant: 'danger',
                    okTitle: 'Confirmar',
                    cancelTitle: 'Cancelar',
                    centered: true
                })
                if (value) {
                    // Remove the students from participants after confirmation
                    var loader = this.$loading.show()
                    try {
                        const payloadData = {
                            courseSiteId: this.activeSite.id,
                            surveyId: this.selectedSurveyObject.id,
                            studentSiteIds: studentSiteId !== null ? [studentSiteId] : this.getAllSelectedStudentSiteIds()
                        }
                        let removedParticipants = await this.removeStudentsFromSurvey(payloadData)
                        const reloadPayload = { courseSiteId: this.activeSite.id, surveyId: this.selectedSurveyObject.id }
                        await this.readSingleSiteTeacherSurvey(reloadPayload)
                        if (removedParticipants > 0) {
                            this.$root.infoToast(`Se han removido ${removedParticipants} participante(s) de esta encuesta/quiz.`)
                        } else {
                            this.$root.warningToast(`Los estudiantes seleccionados no son participantes de la encuesta.`, 'Atención')
                        }
                    } catch (error) {
                        console.log({ error: error })
                        this.$root.dangerToast('No se pudo remover ningun participante de la encuesta/quiz, intente más tarde.')
                    } finally {
                        loader.hide()
                    }
                }
            } catch (error) {
                console.log({ error: error })
                this.unknownErrorToast()
            }
        }
    },
    created () {
        this.selectedBySection = {}
        if (this.selectedSurveyObject !== null) {
            for (var section in this.selectedSurveyObject.sections) {
                this.selectedBySection[section] = []
            }
        }
    }
}
</script>
